import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  RouteReuseStrategy,
  withRouterConfig,
} from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';

import {
  CustomRouteReuseStrategy,
  FU_CONFIG,
  FU_TOAST_CONFIG,
  FU_TOAST_DEFAULT_CONFIG,
  TranslateLoaderService,
} from '@hglobal/fin-ui';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { NgxPermissionsModule } from 'ngx-permissions';

import { ShellStore } from '@iw/shell';
import {
  USER_API,
  UserApiService,
  UserMockApiService,
  UserStore,
} from '@iw/users';

import { environment } from '../environments';
import { appRoutes } from './app.routes';
import { AuthApiServiceMock } from './core/auth-store';
import { AUTH_API, AuthApiService } from './core/auth-store/api';
import { APP_HTTP_INTERCEPTORS } from './core/init';
import { GlobalToastService, IwDialogService } from './core/services';
import { SHELL_API, ShellApiService, ShellMockApiService } from './shell/api';
import {
  DICTIONARIES_API,
  DictionariesApiService,
  DictionariesMockApi,
  DictionariesStore,
} from './store';

const isLocalMode = location.hostname === 'localhost';
const FU = [
  {
    provide: FU_CONFIG,
    useValue: {
      apiHost: environment.apiHost,
      useMocks: environment.useMocks,
      production: environment.production,
    },
  },
  {
    provide: FU_TOAST_CONFIG,
    useValue: { ...FU_TOAST_DEFAULT_CONFIG, closeIconName: 'close-square' },
  },
];

const NGX = [
  importProvidersFrom(
    MatNativeDateModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLoaderService,
        deps: [HttpClient],
      },
    }),
    NgxPermissionsModule.forRoot(),
  ),
  provideNgxMask(),
];

export const ROUTING_CONFIG = [
  provideHttpClient(withInterceptorsFromDi()),
  APP_HTTP_INTERCEPTORS,
  provideRouter(
    appRoutes,
    withRouterConfig({
      paramsInheritanceStrategy: 'always',
    }),
  ),
  {
    provide: RouteReuseStrategy,
    useClass: CustomRouteReuseStrategy,
  },
];

const API = [
  {
    provide: DICTIONARIES_API,
    useClass: environment.useMocks
      ? DictionariesMockApi
      : DictionariesApiService,
  },
  {
    provide: AUTH_API,
    useClass: environment.useMocks ? AuthApiServiceMock : AuthApiService,
  },
  {
    provide: SHELL_API,
    useClass: environment.useMocks ? ShellMockApiService : ShellApiService,
  },
  {
    provide: USER_API,
    useClass: environment.useMocks ? UserMockApiService : UserApiService,
  },
];

const STORE = [DictionariesStore, ShellStore, UserStore];

export const CUSTOM_PROVIDERS_CONFIG = [
  ...NGX,
  ...FU,
  ...API,
  ...STORE,
  provideZoneChangeDetection({ eventCoalescing: true }),
  provideAnimations(),
  provideAnimationsAsync(),
  provideServiceWorker('ngsw-worker.js', {
    enabled: !isLocalMode,
    registrationStrategy: 'registerWhenStable:30000',
  }),
];

export const SERVICES_PROVIDES = [IwDialogService, GlobalToastService];
